import axiosSetup from "../utils/axiosSetup";
import ResponseModel from "../models/response.model";

export const createCampaignApi = async (
  campaignData: FormData,
): Promise<ResponseModel> => {
  const response = await axiosSetup.post(
    "/whatsapp-campaign/create",
    campaignData,
  );
  return response.data;
};

export const editCampaignApi = async (
  campaignId: string,
  campaignData: FormData,
): Promise<ResponseModel> => {
  const response = await axiosSetup.patch(
    `/whatsapp-campaign/edit/${campaignId}`,
    campaignData,
  );
  return response.data;
};

export const getCampaignsApi = async (
  page: number,
  limit: number,
  search?: string,
): Promise<ResponseModel> => {
  const response = await axiosSetup.get("/whatsapp-campaign/list", {
    params: {
      page,
      limit,
      search,
    },
  });
  return response.data;
};

export const getMsgsApi = async (
  campaignId: string,
  page: number,
  limit: number,
  search?: string,
): Promise<ResponseModel> => {
  const response = await axiosSetup.get(
    `/whatsapp-campaign/messages/${campaignId}`,
    {
      params: {
        page,
        limit,
        search,
      },
    },
  );
  return response.data;
};

export const pauseCampaignApi = async (
  campaignId: string,
): Promise<ResponseModel> => {
  const response = await axiosSetup.patch(
    `/whatsapp-campaign/pause/${campaignId}`,
  );
  return response.data;
};

export const resumeCampaignApi = async (
  campaignId: string,
): Promise<ResponseModel> => {
  const response = await axiosSetup.patch(
    `/whatsapp-campaign/resume/${campaignId}`,
  );
  return response.data;
};
